"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBellHeavy(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12.025 2.5a5.593 5.593 0 015.59 5.373l.005.22-.001 4.448 2.176 3.826c.471.945-.089 1.922-1.106 2.002l-.135.005h-3.282l-.002.062a3.249 3.249 0 01-6.491-.061h-3.28c-1.057 0-1.68-.942-1.273-1.928l.056-.124 2.151-3.78v-4.45A5.592 5.592 0 0112.026 2.5zm1.436 15.874H10.59l.002.016a1.44 1.44 0 002.868 0l.001-.016zm2.35-10.281a3.784 3.784 0 00-7.564-.195l-.005.195v4.688a.898.898 0 01-.003.077l.003-.077a.912.912 0 01-.063.334l-.005.012-.018.041a.901.901 0 01-.025.049l-.007.012-1.901 3.337h11.605l-1.899-3.337-.006-.012a.901.901 0 01-.025-.049l.031.06a.912.912 0 01-.118-.421V8.093z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBellHeavy;
exports.default = _default;